import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { environment } from '../../environments/environment';
import { PreviewRequest } from '../models/PreviewRequest';
import { MapService } from '../services/map.service';
import { SettingsService } from './settings.service';
import 'rxjs/add/operator/toPromise';

@Injectable()
export class PreviewService {
  constructor(private http: Http, private mapService: MapService, private settingsService: SettingsService) {}

  requestPreview(previewRequest: PreviewRequest) {
    const { name, email, message, wantsNewsletter } = previewRequest;
    let { map } = previewRequest;

    map = Object.assign({}, this.mapService.toJSON(map), {
      // the map sent to the server does not need the complete style object, the id is enough. This is done
      // to reduce the URL size until we implement map persistence on a database
      style: {
        id: map.style.id,
        name: map.style.name
      }
    });

    return this.http
      .post(`${environment.api}/digital-preview`, {
        name,
        customerEmail: email,
        previewEmail: environment.preview.email,
        message,
        wantsNewsletter,
        mapifierURL: environment.mapifierURL,
        map,
        lang: this.settingsService.getLanguage()
      })
      .toPromise();
  }

  getDigitalPreviewRequestById(id: number): Promise<PreviewRequest> {
    return this.http
      .get(`${environment.api}/digital-preview/${id}`)
      .toPromise()
      .then(res => res.json() as PreviewRequest);
  }
}



// WEBPACK FOOTER //
// /vercel/path0/src/app/services/preview.service.ts